exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.editarTime .h2_title[data-v-4eb7b894] {\n  font-weight: normal;\n}\n", ""]);

// exports
